import AddRoleModal from './add-role-modal.vue'
export default AddRoleModal
